import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    popup_visibility: false,
    subscription_plan: null,
    subscription_product: null,
    bought: false,
    popup_type: ''
  },
  actions: actions,
  mutations: mutations,
  getters: getters
}
